import { StoreIcon } from 'lucide-react';

/** PRATDEV-260: faixa fixa no rodapé da loja, na cor da loja (tema do app) — deixa claro que ali é apenas vitrine. */
export function ShowcaseBanner() {
  return (
    <div
      role="status"
      data-testid="showcase-banner"
      className="flex w-full items-center gap-3 rounded-xl bg-primary px-4 py-3 text-primary-foreground shadow-md"
    >
      <StoreIcon className="h-5 w-5 shrink-0" aria-hidden />
      <div className="min-w-0">
        <p className="text-sm font-bold">Cardápio apenas para consulta</p>
        <p className="text-xs">Esta loja não recebe pedidos por aqui. Veja os itens e os preços.</p>
      </div>
    </div>
  );
}

/** Rodapé do produto no lugar de quantidade + Adicionar. */
export function ShowcaseProductFooter() {
  return (
    <p
      data-testid="showcase-product-footer"
      className="w-full rounded-lg bg-muted px-4 py-3 text-center text-sm font-semibold text-night"
    >
      Apenas vitrine: esta loja não recebe pedidos pelo cardápio digital.
    </p>
  );
}
